import html2Element from "@/utils/html2Element.js";
import noScroll from "@/utils/noScroll.js";

const popupsStack = [];
let currentPopup = null;

export default function showPopup(content, options) {
    const control = {};
    
    popupsStack.push({
        content: content,
        options: options || {},
        control: control
    });

    updateStack();

    return control;
}

function updateStack() {
    if (currentPopup || popupsStack.length < 1) {
        return;
    }

    currentPopup = popupsStack.shift();

    const content = currentPopup.content;
    const options = currentPopup.options;
    const template = options.template || `
        <div class="popup-overlay">
            <div class="popup-window">
                <button type="button" class="popup-close-button">
                    <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z" fill="currentColor"/></svg>
                </button>
                <div class="popup-content"></div>
            </div>
        </div>
    `;

    let popupElement = html2Element(template);
    const popupWindow = popupElement.querySelector('.popup-window');
    const popupCloseButton = popupElement.querySelector('.popup-close-button');
    const popupContent = popupElement.querySelector('.popup-content');
    
    if (options.rootClass) {
        if (Array.isArray(options.rootClass)) {
            options.rootClass.forEach(c => popupElement.classList.add(c));
        } else if (typeof options.rootClass === 'string' || options.rootClass instanceof String) {
            popupElement.classList.add(options.rootClass);
        }
    }

    if (typeof content === 'string' || content instanceof String) {
        popupContent.innerHTML = content;
    } else if (content instanceof HTMLElement) {
        popupContent.appendChild(content);
    } else {
        popupElement.remove();
        updateStack();
    }

    popupElement.addEventListener("click", close);
    popupCloseButton.addEventListener("click", close);
    popupWindow.addEventListener("click", function (event) {
        event.stopPropagation();
        //event.preventDefault();
    });

    setTimeout(function () {
        if (popupElement) {
            popupElement.classList.add("visible");
        }
        noScroll.hideScroll();
    }, 10);

    currentPopup.control.close = close;

    document.body.appendChild(popupElement);

    if (options.onShown) {
        options.onShown(popupElement);
    }

    function close() {
        currentPopup = null;
        if (popupElement) {
            popupElement.addEventListener("transitionend", function(event) {
                if (popupElement) {
                    if (options.keepContentOnClose) {
                        document.body.appendChild(content);
                    }

                    popupElement.remove();
                    popupElement = null;
                    noScroll.showScroll();
                }
            });

            popupElement.classList.remove("visible");
        }
        
        updateStack();
    }
}
